import React from "react";
import { Hero, Testimonial } from "../../../components";

function Index() {
  return (
    <div>
      <Hero />
      <Testimonial />
    </div>
  );
}

export default Index;
